import { IStoreSubscriptionDetailsWidgetData, StoreSubscriptionDetailsWidgetData } from "src/typings/store-subscription-details-data";
import { WidgetRendererBase } from "../widget-renderer-base";
import { StoreSubscriptionDetailsStyleRenderer } from "./store-subscription-details-style-renderer";
import { StoreSubscriptionDetailsWidgetScriptRenderer as StoreSubscriptionDetailsWidgetScriptRenderer } from "./store-subscription-details-script-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class StoreSubscriptionDetailsWidgetRenderer extends WidgetRendererBase<IStoreSubscriptionDetailsWidgetData> {

    private readonly styleRenderer: StoreSubscriptionDetailsStyleRenderer;
    private readonly scriptRenderer: StoreSubscriptionDetailsWidgetScriptRenderer;

    private readonly MODEL_DATA_ATTRIBUTE = "data-subscription-model";

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.styleRenderer = new StoreSubscriptionDetailsStyleRenderer(this.styleService);
        this.scriptRenderer = new StoreSubscriptionDetailsWidgetScriptRenderer();
    }

    protected override renderStyles(element: HTMLElement, data: IStoreSubscriptionDetailsWidgetData): void {
        this.styleRenderer.render(element, data.style);
    }

    protected override createNewInternal(): HTMLElement {
        return this.createWidgetElement("storeSubscriptionDetailsWidget");
    }

    protected override renderInternal(element: HTMLElement, data: IStoreSubscriptionDetailsWidgetData): HTMLElement {
        this.setAttributes(element, data);

        const previousData = this.getData(element);

        this.renderStyles(element, data);
        this.renderScript(element, previousData, data);

        return element;
    }

    private setAttributes(element: HTMLElement, data: IStoreSubscriptionDetailsWidgetData): void {
        if (data.subscriptionDataBase64) {
            element.setAttribute(this.MODEL_DATA_ATTRIBUTE, data.subscriptionDataBase64);
        }

        element.toggleAttribute("data-primary-element", data.primaryElement);
        if (this.isEditorRendering) {
            element.setAttribute("data-draft", "true");
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override cleanupInternal(element: HTMLElement): void {
        // nothing
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [];
    }

    private renderScript(element: HTMLElement, previousData: IStoreSubscriptionDetailsWidgetData | null, data: IStoreSubscriptionDetailsWidgetData): void {
        if (!StoreSubscriptionDetailsWidgetData.isLocalScriptRerenderNeeded(previousData ?? undefined, data)) {
            this.scriptRenderer.renderLocal(element);
        }
    }

}